import React, { useEffect } from 'react'
import Banner from '../components/Banner'
import { useDataContext } from '../context/DataContext';

const TermsAndConditions = () => {
    const { termsConditions, loading, error, fetchTerms } = useDataContext();

    useEffect(() => {
        fetchTerms();
    }, []);

    return (
        <main id="terms-condition">

            <Banner img="assets/yachtimages/06.webp" text="Terms And Condition" />

            <section className="gap container">
                {/* {console.log(termsConditions[0].title)} */}
                <h2>{termsConditions && termsConditions[0].title}</h2>
                {termsConditions && <div dangerouslySetInnerHTML={{ __html: termsConditions[0].description }} />}
                {/* <ol className="h3_list">
                    <li>
                        <h3>Definitions</h3>
                        <ul>
                            <li>
                                <p>
                                    <b>Owner:</b> The company operating the yacht rental services (hereinafter referred to
                                    as "the Company").
                                </p>
                            </li>
                            <li>
                                <p>
                                    <b>Charterer:</b> The individual or entity renting the yacht.
                                </p>
                            </li>
                            <li>
                                <p>
                                    <b>Vessel:</b> The yacht or watercraft provided by the Company for charter.
                                </p>
                            </li>
                            <li>
                                <p>
                                    <b>Crew:</b> The captain and other personnel provided by the Company to operate the
                                    Vessel.
                                </p>
                            </li>
                            <li>
                                <p>
                                    <b>Agreement:</b> The legally binding contract between the Company and the Charterer.
                                </p>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h3>Booking and Payment Terms</h3>
                        <ol>
                            <li>
                                <h5>Reservations</h5>
                                <p>
                                    Reservations are confirmed only upon receipt of a signed Agreement and payment of the
                                    required deposit.
                                </p>
                            </li>
                            <li>
                                <h5>Deposit</h5>
                                <p>
                                    A deposit of 50% of the total charter fee is required at the time of booking to secure
                                    the reservation. The remaining balance must be paid no later than 48 hours prior to the
                                    departure date.
                                </p>
                            </li>
                            <li>
                                <h5>Payment Methods</h5>
                                <p>
                                    The Company accepts payments via credit card, wire transfer, or other approved methods.
                                    All payment information must be valid and accurate.
                                </p>
                            </li>
                            <li>
                                <h5>Cancellation Policy</h5>
                                <ul>
                                    <li>
                                        Cancellation by the Charterer 30 days or more prior to the charter date: Full refund
                                        of the deposit.
                                    </li>
                                    <li>
                                        Cancellation 14 to 29 days before the charter date: 50% refund of the deposit.
                                    </li>
                                    <li>
                                        Cancellation less than 14 days before the charter date: No refund.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h5>Changes and Rescheduling</h5>
                                <p>
                                    Changes to the reservation are subject to availability and may incur additional fees.
                                </p>
                            </li>
                        </ol>
                    </li>
                    <li>
                        <h3>Delivery and Redelivery</h3>
                        <ol>
                            <li>
                                <h5>Delivery</h5>
                                <p>
                                    The Company will deliver the Vessel in seaworthy condition, equipped with all necessary
                                    safety equipment as per U.S. Coast Guard requirements.
                                </p>
                            </li>
                            <li>
                                <h5>Redelivery</h5>
                                <p>
                                    The Charterer must return the Vessel to the agreed location in the same condition as
                                    received, excluding normal wear and tear.
                                </p>
                            </li>
                            <li>
                                <h5>Late Redelivery</h5>
                                <p>
                                    Late return of the Vessel will result in additional fees charged at 150% of the hourly
                                    rate.
                                </p>
                            </li>

                        </ol>
                    </li>
                    <li>
                        <h3>Usage of the Vessel</h3>
                        <ol>
                            <li>
                                <h5>Permitted Use</h5>
                                <p>
                                    The Vessel may only be used for private, recreational purposes and within the designated
                                    cruising areas specified in the Agreement.
                                </p>
                            </li>
                            <li>
                                <h5>Behavior and Conduct</h5>
                                <p>
                                    The Charterer and their guests must comply with all instructions from the captain and
                                    crew. Unruly behavior, including harassment, illegal activities, and excessive alcohol
                                    consumption, is prohibited.
                                </p>
                            </li>
                            <li>
                                <h5>Children and Pets</h5>
                                <p>
                                    The Charterer is responsible for the supervision of children on board. Pets are not
                                    allowed unless explicitly authorized in writing.
                                </p>
                            </li>
                            <li>
                                <h5>Prohibited Items</h5>
                                <p>
                                    Firearms, explosives, illegal drugs, and any other hazardous materials are strictly
                                    prohibited on board.
                                </p>
                            </li>
                        </ol>
                    </li>
                    <li>
                        <h3>Insurance and Liability</h3>
                        <ol>
                            <li>
                                <h5>Owner’s Insurance</h5>
                                <p>
                                    The Vessel is insured for standard risks, including third-party liability. This does not
                                    cover damages or injuries caused by the negligence or willful misconduct of the
                                    Charterer or their guests.
                                </p>
                            </li>
                            <li>
                                <h5>Charterer’s Responsibility</h5>
                                <p>
                                    The Charterer is liable for: Damage to the Vessel or its equipment due to negligence.
                                    Injuries to guests or third parties resulting from misconduct or non-compliance with
                                    instructions.
                                </p>
                            </li>
                            <li>
                                <h5>Disclaimer of Liability</h5>
                                <p>
                                    The Company is not liable for: Injuries, losses, or damages occurring during the charter
                                    unless caused by gross negligence of the Company. Accidents or injuries during
                                    participation in water sports or other activities.
                                </p>
                            </li>
                        </ol>
                    </li>
                    <li>
                        <h3>Indemnity</h3>
                        <p>
                            The Charterer agrees to indemnify and hold the Company harmless against all claims, liabilities,
                            damages, or losses arising from the Charterer’s or their guests’ actions.
                        </p>
                    </li>
                    <li>
                        <h3>Safety and Compliance</h3>
                        <ol>
                            <li>
                                <h5>Compliance with Laws</h5>
                                <p>
                                    The Charterer and guests must comply with all applicable local, state, and federal laws,
                                    including U.S. Coast Guard regulations.
                                </p>
                            </li>
                            <li>
                                <h5>Captain’s Authority</h5>
                                <p>
                                    The captain has full authority over the Vessel and may terminate the charter or refuse
                                    services if the Charterer or guests pose a safety risk.
                                </p>
                            </li>
                            <li>
                                <h5>Emergency Situations</h5>
                                <p>
                                    In emergencies, the captain may alter the route or terminate the charter to ensure
                                    safety.
                                </p>
                            </li>
                        </ol>
                    </li>
                    <li>
                        <h3>Water Sports and Activities</h3>
                        <ol>
                            <li>
                                <h3>Participation at Own Risk</h3>
                                <p>
                                    Participation in water sports is at the Charterer’s and guests’ own risk. A signed
                                    waiver is required for all participants.
                                </p>
                            </li>
                            <li>
                                <h5>Prohibited Behavior</h5>
                                <p>
                                    Use of water sports equipment while under the influence of alcohol or drugs is strictly
                                    prohibited.
                                </p>
                            </li>
                        </ol>
                    </li>
                    <li>
                        <h3>Force Majeure</h3>
                        <p>
                            The Company is not liable for cancellations or interruptions due to force majeure events,
                            including severe weather, mechanical failure, or government restrictions. In such cases, the
                            Company may reschedule the charter or provide a refund at its discretion.
                        </p>
                    </li>
                    <li>
                        <h3>Governing Law and Dispute Resolution</h3>
                        <ol>
                            <li>
                                <h5>Jurisdiction</h5>
                                <p>
                                    This Agreement is governed by the laws of the State of Florida, USA.
                                </p>
                            </li>
                            <li>
                                <h5>Dispute Resolution</h5>
                                <p>
                                    Any disputes arising under this Agreement will be resolved through arbitration in Dubai,
                                    Florida.
                                </p>
                            </li>

                        </ol>
                    </li>
                    <li>
                        <h3> Acknowledgment and Acceptance</h3>
                        <p>
                            By signing this Agreement and making payment, the Charterer acknowledges they have read,
                            understood, and agreed to these Terms and Conditions.
                        </p>
                        <p>
                            Let me know if you need any changes or additional clauses!
                        </p>
                    </li>
                </ol> */}
            </section>

        </main>
    )
}

export default TermsAndConditions